import { useEffect } from 'react'

import { usePrivy } from '@privy-io/react-auth'

import { useApp } from 'store/app/hooks'
import { useAppLogin } from 'hooks/useAppLogin'

/**
 * Legacy email/password auth modal.
 *
 * Cyberlete is Privy-only — the old SignIn/SignUp forms here were dead
 * (their submit handlers were disabled), so a guest who hit a flow that
 * opened this modal (team join, posting a comment, voting, etc.) saw a
 * form that could never log them in.
 *
 * This component now honors those legacy `setIsSignInModalOpen` /
 * `setIsSignUpModalOpen` requests by opening Privy's real login modal
 * instead. All auth still goes through Privy.
 */
export const AuthModal = () => {
  const {
    isSignUpModalOpen,
    isSignInModalOpen,
    setIsSignUpModalOpen,
    setIsSignInModalOpen,
  } = useApp()
  const { authenticated } = usePrivy()
  const { login } = useAppLogin()

  const wantsAuth = isSignInModalOpen || isSignUpModalOpen

  useEffect(() => {
    if (!wantsAuth) return

    // Clear the legacy flags right away so this only fires once.
    setIsSignInModalOpen(false)
    setIsSignUpModalOpen(false)

    // Nothing to do if they're already authenticated.
    if (!authenticated) login()
  }, [
    wantsAuth,
    authenticated,
    login,
    setIsSignInModalOpen,
    setIsSignUpModalOpen,
  ])

  return null
}
